const MOJIBAKE_MARKERS = /[\u00C3\u00C5\u00C4\u00E2\uFFFD]/;

function decodeLatin1AsUtf8(input) {
  try {
    return Buffer.from(input, 'latin1').toString('utf8');
  } catch (_) {
    return input;
  }
}

function normalizePunctuation(input) {
  return input
    .replace(/[\u2018\u2019\u2032]/g, "'")
    .replace(/[\u201C\u201D\u2033]/g, '"')
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/\u2026/g, '...')
    .replace(/\u00A0/g, ' ')
    .replace(/\uFFFD/g, '');
}

export function repairMojibake(value) {
  if (value === null || value === undefined) return '';
  let s = String(value);

  for (let i = 0; i < 3; i += 1) {
    const before = s;
    if (MOJIBAKE_MARKERS.test(s)) {
      s = decodeLatin1AsUtf8(s);
    }
    s = normalizePunctuation(s);
    if (s === before) break;
  }

  return s.replace(/\s{2,}/g, ' ').trim();
}

export function repairMojibakeList(values) {
  if (!Array.isArray(values)) return [];
  return values.map((v) => repairMojibake(v)).filter(Boolean);
}
